import { ActivityIndicator, FlatList, View } from "react-native";

import EventListItem from "../EventListItem";

import { EventListProps } from "./types";

const EventList: React.FC<EventListProps> = ({ data, loading }) => (
  <View style={{ flex: 1 }}>
    {loading && <ActivityIndicator />}
    <FlatList
      {...{ data }}
      keyExtractor={({ id }) => id}
      renderItem={({ item }) => <EventListItem {...item} />}
      style={{ flexBasis: 1 }}
    />
  </View>
);

export default EventList;
